import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import AuthorData from "../../../data/authors.json";
// import BlogData from "../../../data/pedia.json";
import PageHead from "@/pages/Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import ProviderSingle from "@/components/Pedia/ProviderSingle";
import BlogListItems from "@/components/Blogs/Blog-Sections/BlogList-Items";
import Instagram from "@/components/Instagram/Instagram";
import ProviderBreadCrumb from "@/components/Pedia/ProviderBreadCrumb";
// import { serialize } from 'next-mdx-remote/serialize'
// import { readFile } from 'fs/promises'
import CPStaticContent from '../../../models/CPStaticContent.js'
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";
// import LinkButton from "@/components/Button/LinkButton";
// import DisqusComments from "@/components/Common/DisqusComments";
// import CPStaticContent2 from '../../../models/CPStaticContent2.js'
import BlogDetails from "@/components/Blogs/BlogDetails";
import BlogBreadCrumb from "@/components/Common/Blog-BreadCrumb";

export default function SingleProvider(post) {
  const router = useRouter();
  const marketplaceId = router.query.postId;

  const mdxSource = post.content
  const allProviders = post.list
  const matchedBlog = post.info

  const authors = JSON.parse(JSON.stringify(AuthorData.authorList));
  const Author = authors.find((author) => author.id === "akbar-hussain");
  matchedBlog['author'] = [Author]

  useEffect(() => {
    if (marketplaceId && !matchedBlog) {
      router.push("/marketplaces");
    }
  }, [matchedBlog, router]);

  return (
    <>
      <PageHead post={matchedBlog} category="Marketplace" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <div className="rbt-overlay-page-wrapper">
            {/* <ProviderBreadCrumb matchedBlog={matchedBlog} categoryPath={"/marketplaces"} /> */}
            <BlogBreadCrumb blogType="marketplace" matchedBlog={matchedBlog} categoryName={"Marketplaces"} categoryPath={"/marketplaces"} />

            <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
              <div className="blog-content-wrapper rbt-article-content-wrapper">


                {/* <ProviderSingle
                  blogType={"marketplace"}
                  matchedBlog={matchedBlog !== undefined ? matchedBlog : ""}
                  blogContent={mdxSource}
                  author={Author}
                /> */}

                <BlogDetails
                  blogType={"marketplace"}
                  matchedBlog={matchedBlog !== undefined ? matchedBlog : ""}
                  blogContent={mdxSource}
                  author={Author}
                />

                {/* <LinkButton text="Visit Marketplace" url={matchedBlog.external_url} />
                <br />
                {
                  (matchedBlog.provider.id === "google") ?
                    <span><Link className="rbt-badge-2" href="https://www.dpbolvw.net/click-101154220-15255256" target="_blank">Built by developers, for developers. Get started on Google Cloud today and receive $350 in product credits.</Link></span> : <span></span>
                } */}

                {/* <DisqusComments blogType="marketplace" blog={matchedBlog} /> */}


                <div className="related-post pt--60">
                  <div className="section-title text-start mb--40">
                    <span className="subtitle bg-primary-opacity">
                      Continue Exploring
                    </span>
                    <h4 className="title">Other Marketplaces</h4>
                  </div>
                  <BlogListItems
                    blogType={"marketplace"}
                    selectedBlogs={allProviders}
                    itemIdToAvoid={marketplaceId}
                  />
                </div>
                <br /><br />
                <GoogleAdLarge />
              </div>
            </div>
            <Instagram />
          </div>

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("marketplaces")
  await stContent.fetchContent()
  return await stContent.getItemProps(context.params.postId)
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("marketplaces")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}